import { ValueOf } from "../type";

export const MsaKey = {
  Waken: "waken",
} as const;

export type MsaKeyType = ValueOf<typeof MsaKey>;
